module.exports = __webpack_public_path__ + "static/media/Images.02b8181d.png";